/* LiftPro vehicle reference. Generated only from the final compatibility master.
 * Shopify metaobjects and the previous cached vehicle tree are not consulted.
 */
(function () {
  "use strict";
  var promise = null;
  var VERSION = "master-2026-11-03-expanded";

  function validate(tree) {
    if (!tree || tree.version !== VERSION || !Array.isArray(tree.makes) || !tree.makes.length) {
      throw new Error("Invalid LiftPro master vehicle tree");
    }
    tree.makes.forEach(function (make) {
      if (!make.n || !make.h || !Array.isArray(make.models) || !make.models.length) throw new Error("Invalid make");
      make.models.forEach(function (model) {
        if (!model.n || !model.h || !Array.isArray(model.gens) || !model.gens.length) throw new Error("Invalid model");
        model.gens.forEach(function (gen) {
          if (!gen.n || !gen.h || (gen.h.indexOf("master-") !== 0 && gen.h !== "ram-promaster-2013-present") || !gen.y1) throw new Error("Invalid generation");
        });
      });
    });
    try {
      localStorage.removeItem("liftpro_vehicle_tree_v1");
      if (localStorage.getItem("liftpro_vehicle_master_version") !== VERSION) {
        localStorage.removeItem("liftpro_vehicle");
        localStorage.setItem("liftpro_vehicle_master_version", VERSION);
      }
    } catch (e) { /* Storage may be unavailable in private browsing. */ }
    return tree;
  }

  function load() {
    if (promise) return promise;
    var cfg = window.LiftProConfig || {};
    var element = document.querySelector("[data-tree-url]");
    var url = cfg.treeUrl || (element && element.getAttribute("data-tree-url"));
    if (!url) return Promise.reject(new Error("LiftPro master vehicle URL is missing"));
    promise = fetch(url).then(function (response) {
      if (!response.ok) throw new Error("LiftPro master vehicle data could not be loaded");
      return response.json();
    }).then(validate).catch(function (error) {
      promise = null;
      throw error;
    });
    return promise;
  }

  window.LiftProVehicles = {
    load: load,
    clearCache: function () {
      promise = null;
      try { localStorage.removeItem("liftpro_vehicle_tree_v1"); } catch (e) {}
    }
  };
})();
